import React, { useEffect, useState } from 'react';
import { Location, Outlet, useLocation } from 'react-router-dom';
import { ActivityIndicator, View } from 'react-native';
import Splashscreen from '../../../shared/components/Splashcreen/Splashscreen';
import { AppTarget, getAppTarget } from './Host';
import CasSplashscreen from '../../../shared/components/Splashcreen/CasSplashscreen';
import DeepLink from "../../../shared/services/DeepLink/DeepLink";
import { useAuthSession } from '../../services/Authentication/AuthProvider';

interface ProtectedRouteProps {

}

export const ProtectedRoute = (props: ProtectedRouteProps) => {

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const session = useAuthSession();
  const location: Location = useLocation();

  useEffect(() => {
    if ((session.status === "anonymous") || (session.status === "authenticated")) {
      setIsLoading(false);
    }
  }, [session]);

  const getContent = () => {
    if (isLoading === true) {
      return <View style={{ width: "100%", height: "100%" }}>
        <ActivityIndicator color={"0000FF"} />
      </View>
    }

    const deepLink: DeepLink = DeepLink.getInstance();
    const connextionStatus = session.status === "authenticated";
    console.log({ connextionStatus, deepLink });
    if ((connextionStatus === false) || (deepLink.last_urls.length === 0)) {
      deepLink.path = location.pathname;
      const appTarget: AppTarget = getAppTarget();
      if ((appTarget === "public") || (appTarget === "gar-preprod")) {
        return <Splashscreen />;
      } else {
        return <CasSplashscreen />;
      }
    }
    return <Outlet key={location.pathname} />;
  }

  return getContent();
};
